import integration from './integration';

export default integration;
